import React, { Component } from 'react';
import { Outlet } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Toasts from '../Components/Toasts';
import Loading from '../Components/Loading';

export class LayoutEmpty extends Component {
    static displayName = LayoutEmpty.name;

    render() {
        return (
            <div className="App">
                <Toasts />
                <Container>
                    <Outlet />
                    <Loading />
                </Container>
            </div>
        );
    }
}